<template>
  <Quizz/>  
</template>

<script>
  import Quizz from '../components/cequizz'

  export default {
    name: 'Home',

    components: {
      Quizz,
    },
  }
</script>
